import axios from 'axios';
import React, { useEffect, useState } from 'react';
import SaveModal from '../modal/saveModal';
import Loader from '../common/loader';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import '../../common/css/listPage.css';

function NoticeIndex() {
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);
    const [searchData, setSearchData] = useState('');
    const [list, setList] = useState([]);
    const [isWait, setIsWait] = useState(false);

    const [status, setStatus] = useState({
        0: '요청중',
        1: '접수완료',
        2: '접수불가(여정 불일치)',
        3: '접수불가(티켓/예약 조회불가))',
        4: '접수불가(INVOL 케이스 아님)',
        5: '접수불가(BCC UNMATCH)',
        6: '접수불가(기존예약 미취소)',
        7: '기타',
        8: '접수불가(유효기간 이후)',
    });

    // 페이지네이션
    const [maxPage, setMaxPage] = useState(5);
    const [minPage, setMinPage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState('');
    const navigate = useNavigate();

    // 서버통신
    useEffect(() => {
        const axiosData = async () => {
            try {
                const params = new URLSearchParams(window.location.search);
                const page = params.get('pageNumber') ?? 1;

                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }

                const response = await axios.get(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/invol/list?pageNumber=${page}`,
                    {
                        withCredentials: true,
                    },
                );
                setList(response.data);
                setTotalPage(Math.ceil(response.data.total / 10));
                setCurrentPage(parseInt(page));
            } catch (error) {
                setModalContent(error?.response?.data?.message);
                setModalAction(() => () => (window.location.href = '/login'));
                setSaveStatus(false);            }
        };
        if (Cookies.get('isLogin')) {
            axiosData();
        } else {
            setModalContent('로그인 후 이용 가능한 서비스 입니다.');
            setModalAction(() => () => (window.location.href = '/login'));
            setSaveStatus(false);
        }
    }, []);

    const pagnation = () => {
        let result = [];
        if (currentPage == 1 || currentPage == 2) {
            for (let index = minPage; index <= maxPage && index <= totalPage; index++) {
                result.push(
                    <li key={index} className={`${currentPage == index ? 'on' : ''}`}>
                        <a onClick={() => updateURL(index)}>{index}</a>
                    </li>,
                );
            }
        } else {
            let startPage = Math.max(1, currentPage - 2);
            let endPage = Math.min(totalPage, currentPage + 2);
            for (let index = startPage; index <= endPage; index++) {
                result.push(
                    <li key={index} className={`${currentPage == index ? 'on' : ''}`}>
                        <a onClick={() => updateURL(index)}>{index}</a>
                    </li>,
                );
            }
        }
        return result;
    };

    // 페이지 네이션 클래스를 위한 URL 업데이트
    const updateURL = (index) => {
        navigate(`?pageNumber=${index}&search=${searchData}`, { replace: true });
        setCurrentPage(index);
        searchDataResult(index);
    };

    // 이전 및 다음 버튼 클릭 이벤트
    const pagnationBtn = (type) => {
        if (type === 'prev' && currentPage > 1) {
            updateURL(currentPage - 1);

            if (currentPage - 1 < minPage) {
                setMaxPage(maxPage - 1);
                setMinPage(minPage - 1);
            }
        } else if (type === 'next' && currentPage < totalPage) {
            updateURL(currentPage + 1);

            if (currentPage + 1 > maxPage) {
                setMaxPage(maxPage + 1);
                setMinPage(minPage + 1);
            }
        } else {
            alert(type === 'prev' ? '첫번째 페이지입니다.' : '마지막 페이지입니다.');
        }
    };
    // 검색 이벤트
    const searchDataResult = async (pagenumber) => {
        try {
            
            const hostname = window.location.hostname;
            let isLocal = null;
            if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                isLocal = false;
            } else {
                isLocal = true;
            }

            const response = await axios.get(
                `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/invol/list?pageNumber=${
                    pagenumber ?? 1
                }&search=${searchData}`,
                {
                    withCredentials: true,
                },
            );
            setList(response.data);
            setTotalPage(Math.ceil(response.data.total / 10));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // 리스트 map 끝나는 순간
    useEffect(() => {
        if (list?.list || list?.list?.length > 0) {
            setIsWait(true);
        }

        if (Cookies.get('isLogin') == null) {
            setIsWait(true);
        }
    }, [list]);

    return (
        <>
            {!isWait && <Loader list={'true'} />}
            <div
                id='contents'
                className='notice-contents'
                style={{ display: isWait ? '' : 'none' }}
            >
                <div class='subp_h_wrap'>
                    <div class='subp_h_list subp_h_home'>
                        <div>서비스요청</div>
                        <div>INVOL 재발행 요청</div>
                        <div>요청 내역 확인</div>
                    </div>
                </div>
                <div class='page_hgroup'>
                    <h2 class='title'>INVOL 재발행 요청 내역</h2>
                </div>

                <div class='notice_list_wrap wait_list'>
                    <div class='notice_list'>
                        <div class='list_top_cont'>
                            <p class='pager'>
                                총 <span class='num'>{list.total}</span>건
                            </p>
                            <div class='search_box notice_search_box'>
                                <input
                                    type='text'
                                    class='search'
                                    placeholder='검색어를 입력하세요'
                                    value={searchData}
                                    onChange={(e) => setSearchData(e.target.value)}
                                />
                                <button
                                    class='button'
                                    onClick={() => {
                                        searchDataResult();
                                    }}
                                />
                            </div>
                        </div>

                        <div class='list_cont'>
                            <ul class='list' style={{ margin: '0px' }}>
                                <li>
                                    <a>
                                        <span className='menu-index'>No</span>
                                        <span class='txt reissue-number'>예약번호</span>
                                        <span class='ticket-number'>티켓번호</span>
                                        <span className='menu-status reissue-status'>상태</span>
                                        <span class='date'>등록일</span>
                                        <span class='completion-date'>처리일</span>
                                    </a>
                                </li>
                            </ul>
                            <ul class='list'>
                                {list.list?.map((data, index) => (
                                    <li class='fix' key={index}>
                                        <a href={`/service/involreissuedetail?seq=${data.seq}`}>
                                            <span class='ico'>{data.seq}</span>
                                            <span class='txt reissue-number'>
                                                {data.air_pnr == ''
                                                    ? '예약번호를 찾을수 없습니다.'
                                                    : data.air_pnr}
                                            </span>
                                            <span class='passenger-name'>
                                                {data.tkt_number == ''
                                                    ? '예약번호를 찾을수 없습니다.'
                                                    : data.tkt_number}
                                            </span>
                                            <span
                                                class='menu-status reissue-status status-text'
                                                style={
                                                    status[data.status]?.includes('접수불가')
                                                        ? { color: 'var(--color-red)' }
                                                        : {}
                                                }
                                            >
                                                {status[data.status]}
                                            </span>
                                            <span class='date'>{data.regDate?.split('T')[0]}</span>
                                            <span class='completion-date'>
                                                {data.commitDate?.split('T')[0]}
                                            </span>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div class='pagenation'>
                            <div class='pagenation_inner'>
                                <a
                                    class={`prev_page`}
                                    onClick={() => {
                                        pagnationBtn('prev');
                                    }}
                                >
                                    이전페이지
                                </a>
                                <ul>{pagnation()}</ul>
                                <a
                                    class={`next_page`}
                                    onClick={() => {
                                        pagnationBtn('next');
                                    }}
                                >
                                    다음페이지
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
            </div>
        </>
    );
}

export default NoticeIndex;
